import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'sales-source:projects'

function read(): string[] {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : []
  } catch {
    return []
  }
}

/** Tracks which projects have been unlocked with their own password this session. */
export function useProjectAccess() {
  const [unlockedIds, setUnlockedIds] = useState<string[]>([])

  useEffect(() => {
    setUnlockedIds(read())
  }, [])

  const grant = useCallback((projectId: string) => {
    setUnlockedIds((previous) => {
      if (previous.includes(projectId)) return previous
      const next = [...previous, projectId]
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next))
      } catch {
        /* session storage unavailable — keep in memory only */
      }
      return next
    })
  }, [])

  const revokeAll = useCallback(() => {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY)
    } catch {
      /* noop */
    }
    setUnlockedIds([])
  }, [])

  const hasAccess = useCallback(
    (projectId: string) => unlockedIds.includes(projectId),
    [unlockedIds],
  )

  return { unlockedIds, hasAccess, grant, revokeAll }
}
